import { GsbPropertyDef } from './gsb-entity-def.model';
import { DataType } from './gsb-entity-def.model';

export const BASE_PROPERTY_DEFINITIONS: GsbPropertyDef[] = [
  {
    "id": "924acba8-58c5-4881-940d-472ec01eba5f",
    "dataType": DataType.Reference,
    "title": "Entity Reference",
    "description": "Reference",
    "name": "Reference",
    "usage": 0
  },
  {
    "id": "d09348ab-5e69-4799-b695-539219a1e060",
    "dataType": DataType.Decimal,
    "maxLength": 18,
    "title": "Money",
    "name": "money",
    "usage": 1,
    "scale": 4
  },
  {
    "id": "045e88ec-fc27-491d-9ab1-fc1b921b3783",
    "dataType": DataType.StringUnicode,
    "title": "Javascript",
    "name": "javascript",
    "usage": 1
  },
  {
    "id": "12e647e0-ebd2-4ec2-a4e3-82c1dfe07da2",
    "dataType": DataType.DateTime,
    "title": "Date/Time",
    "description": "DateTime",
    "name": "DateTime",
    "usage": 0
  },
  {
    "id": "35efcf9c-fff0-44d4-8972-73a9a32b93fa",
    "dataType": DataType.Decimal,
    "title": "Number",
    "description": "Number",
    "name": "Number",
    "usage": 0
  },
  {
    "id": "ac770fe2-c99a-450f-91ee-c01496281d3d",
    "dataType": DataType.Decimal,
    "maxLength": 12,
    "title": "Quantity",
    "name": "quantity",
    "usage": 1,
    "scale": 4
  },
  {
    "id": "7868afdf-2709-45be-87e3-87de8d35f30f",
    "dataType": DataType.Bool,
    "title": "Boolean",
    "description": "Bool",
    "name": "Bool",
    "usage": 0
  },
  {
    "id": "75ba1aca-5c49-424f-be1a-9fbefb20d0b5",
    "dataType": DataType.Decimal,
    "maxLength": 12,
    "title": "Time Span",
    "name": "timeSpan",
    "usage": 1,
    "scale": 0
  },
  {
    "id": "1c48b9fd-8ee9-499c-8c45-a1dd98cc03b0",
    "dataType": DataType.JSON,
    "title": "JSON",
    "name": "json",
    "usage": 1
  },
  {
    "id": "947930b6-bd23-47b9-b422-790c8792dad6",
    "dataType": DataType.Int,
    "title": "Integer",
    "description": "Int",
    "name": "Int",
    "usage": 1
  },
  {
    "id": "7a5ec8d1-fbac-4d94-98fa-0f5f53c292a0",
    "dataType": DataType.StringUnicode,
    "title": "Css",
    "name": "css",
    "usage": 1
  },
  {
    "id": "5c0aa76f-9c32-4e7e-a4bc-b56e93877883",
    "dataType": DataType.StringUnicode,
    "title": "id",
    "description": "EIxId",
    "name": "id",
    "usage": 1
  },
  {
    "id": "df7ce94b-d59c-4b67-8519-aa4c98ab477c",
    "dataType": DataType.StringUnicode,
    "maxLength": 320,
    "title": "E-Mail",
    "description": "EMail",
    "name": "EMail",
    "regex": "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$",
    "usage": 1
  },
  {
    "id": "b57fea01-0b06-4977-9537-952720253802",
    "dataType": DataType.Decimal,
    "title": "Decimal",
    "description": "Decimal",
    "name": "Decimal",
    "usage": 1
  },
  {
    "id": "e0e03719-ee27-41b1-9452-d441c291fa5e",
    "dataType": DataType.StringUnicode,
    "title": "Html",
    "name": "html",
    "usage": 1
  },
  {
    "id": "7bf08f4f-7de0-469e-bbfb-f4c43762f4d7",
    "dataType": DataType.Enum,
    "title": "Select List",
    "description": "Enum",
    "name": "Enum",
    "usage": 0
  },
  {
    "id": "e07f578e-2705-49c1-b97f-3ca5963c67c0",
    "dataType": DataType.StringUnicode,
    "maxLength": 2048,
    "title": "RichText",
    "description": "Multiline formatted text",
    "name": "RichText",
    "usage": 0
  },
  {
    "id": "4273028f-9ff7-4741-aef4-966d772f4e11",
    "dataType": DataType.StringASCII,
    "title": "Base64",
    "name": "base64",
    "usage": 1
  },
  {
    "id": "7291fbc2-a7cf-4713-a876-0cff085cc035",
    "dataType": DataType.StringUnicode,
    "maxLength": 320,
    "title": "Password",
    "description": "Password",
    "name": "Password",
    "usage": 1
  },
  {
    "id": "00283294-a0d0-4a80-ba91-5e309c8542c2",
    "dataType": DataType.StringUnicode,
    "maxLength": 256,
    "title": "Ml Text",
    "description": "Multilingual text",
    "name": "MlText",
    "usage": 1
  },
  {
    "id": "f7b0f336-a2fa-43bd-97a4-b096aab76077",
    "dataType": DataType.StringUnicode,
    "maxLength": 64,
    "title": "Icon",
    "name": "icon",
    "usage": 1
  },
  {
    "id": "3623b7bc-7884-4989-aed0-e9f31c0693ea",
    "dataType": DataType.Reference,
    "title": "Image",
    "name": "image",
    "usage": 1
  },
  {
    "id": "c6c34bf3-f51b-4e69-a689-b09847be74b9",
    "dataType": DataType.StringUnicode,
    "maxLength": 1024,
    "title": "Text",
    "description": "Text",
    "name": "Text",
    "usage": 0
  },
  {
    "id": "dfa41997-3031-42d0-bab3-0302f1d1db1b",
    "dataType": DataType.Binary,
    "title": "Binary",
    "description": "Binary",
    "name": "Binary",
    "usage": 1
  },
  {
    "id": "e03f84c0-774d-4c9a-9c90-cb68a6ce8462",
    "dataType": DataType.Long,
    "title": "Token",
    "description": "Token",
    "name": "Token"
  },
  {
    "id": "3513db3c-a1a7-464d-adab-05dbec8117e0",
    "dataType": DataType.Long,
    "title": "Long",
    "description": "Long",
    "name": "Long"
  }
]; 